import { EditedUnloadEventHistoryItem } from "src/models/History";
import { toEventHistoryItem } from "../to-event-history-item";

export function toEditedUnloadEventHistoryItem(data: any): EditedUnloadEventHistoryItem {
    const row = toEventHistoryItem(data);
    const editedUnload = data as EditedUnloadEventHistoryItem;
    row.details = {
        originalData: [
          {attribute: 'posição', value: editedUnload.forkliftPosition.groundPositionAlias || '---'},
          {attribute: 'nível', value: editedUnload.forkliftPosition.groundPositionGroupLevelName || '---'},
          {attribute: '(x, y, z)', value: `(${[editedUnload.forkliftPosition.x.toString(), editedUnload.forkliftPosition.y.toString(), editedUnload.forkliftPosition.z.toString()].join(', ')})`},
        ],
        editedData: [
          {attribute: 'posição', value: editedUnload.groundPositionAlias || '---'},
          {attribute: 'nível', value: editedUnload.groundPositionGroupLevelName || '---'},
          {attribute: '(x, y, z)', value: `(${[editedUnload.x.toString(), editedUnload.y.toString(), editedUnload.z.toString()].join(', ')})`},
        ],
      };
      return row;
}
  